export default __webpack_public_path__ + "static/media/unicorn_logo.b2f898bc.png";